import { AI_UPDATE_STATE } from '.';

export const setAIChatState = state => ({
  type: AI_UPDATE_STATE,
  payload: {
    isChatOpen: state,
  },
});
